import { useQueryClient } from '@tanstack/react-query';

export function useRefreshCustomer() {
  const queryClient = useQueryClient();
  return () => {
    queryClient.invalidateQueries({ queryKey: ['customer'] });
  };
}